<template>
    <div class="container page-content mt-10">
        <div class="row">
            <div class="col-12">
                <h1 class="page-heading text-dark">
                    ADMIN ZONE ⚠️
                </h1>
            </div>

            <div class="col-12 mb-4" style="white-space: nowrap">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation" v-on:click="tab = 'shortcuts'">
                        <h5 class="nav-link active" id="current-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Shorts</h5>
                    </li>
                    <li class="nav-item" role="presentation" v-on:click="tab = 'seeds'">
                        <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Seeds</h5>
                    </li>
                    <li class="nav-item" role="presentation" v-on:click="tab = 'give'">
                        <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Give</h5>
                    </li>
                    <li class="nav-item" role="presentation" v-on:click="tab = 'notify'">
                        <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Notify</h5>
                    </li>
                </ul>
            </div>

            <div class="col-12 mb-5" v-if="tab === 'shortcuts'">
                <a href="/fight" class="btn btn-dark w-100 mb-2">CardFight Prototype</a>
                <a href="/fishing" class="btn btn-dark w-100 mb-2">Fishing Prototype</a>
                <a href="/product-gallery" class="btn btn-dark w-100 mb-2">Product Gallery</a>
                <a href="/booster-gallery" class="btn btn-dark w-100 mb-2">Booster Gallery</a>
                <a href="/demo" class="btn btn-dark w-100 mb-2">Open Demo Page</a>
            </div>

            <div class="col-12" v-if="tab === 'seeds'">
                <button class="btn btn-danger mb-2 me-3" v-on:click="regenerateShopItems">
                    REGENERATE SHOP ITEMS
                </button>
                <button class="btn btn-danger mb-2" v-on:click="importSets">
                    {{ importSetsRunning ? 'IMPORT ALREADY RUNNING; STOP IT' : 'UPDATE CARD-SETS' }}
                </button>
<!--                <button class="btn btn-danger w-100 mb-2" v-on:click="importCards">-->
<!--                    {{ importCardsRunning ? 'WAIT ABOUT 10 MINUTES' : 'UPDATE CARDS (TRAU DI OIDA)' }}-->
<!--                </button>-->
            </div>

            <div class="col-12" v-if="tab === 'seeds'">
                <label for="user">Seeder-Output</label>
                <textarea class="form-control" v-model="outputLog" style="font-size: 0.75em; height: 30em;"></textarea>
            </div>

            <div class="col-12 mt-3" v-if="tab === 'seeds'">
                <h5>Reset user password</h5>
                <div class="form-group">
                    <label for="user">User</label>
                    <select name="user" id="user" class="form-control mb-2" v-model="passwordReset.userId">
                        <option v-for="user in users" :value="user.id" v-text="user.username"></option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="userPW">New password</label>
                    <input type="text" v-model="passwordReset.newPassword" class="form-control" id="userPW">
                </div>
                <div class="form-group mt-2">
                    <a href="javascript:" class="btn btn-sm btn-danger w-100" v-on:click="resetUserPassword">Set user password</a>
                </div>
            </div>

            <div class="col-12" v-if="tab === 'give'">
                <h5>Give boosters to user</h5>
                <div class="form-group">
                    <label for="user">User</label>
                    <select name="user" id="user" class="form-control mb-2" v-model="giveBoosters.userId">
                        <option v-for="user in users" :value="user.id" v-text="user.username"></option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="booster">Set</label>
                    <select name="booster" id="booster" class="form-control mb-2" v-model="giveBoosters.boosterSetId">
                        <optgroup v-for="(series, seriesName) in setGroups" :label="seriesName">
                            <option v-for="set in series" :value="set.set_id" v-text="set.set_name"></option>
                        </optgroup>
                    </select>
                </div>
                <div class="form-group my-3">
                    <label for="count">Count</label>
                    <input type="range" class="form-range" min="1" max="50" v-model="giveBoosters.count" id="count"/>
                </div>
                <div class="form-group">
                    <a href="javascript:" class="btn btn-sm btn-danger w-100" v-on:click="giveBoostersToUser">Give user {{ giveBoosters.count }} boosters</a>
                </div>
            </div>

            <div class="col-12" v-if="tab === 'notify'">
                <h5>Notify all users</h5>
                <div class="form-group">
                    <label for="message">Message</label>
                    <textarea name="message" id="message" class="form-control mb-2" v-model="notify.message"></textarea>
                </div>
                <div class="form-group">
                    <label for="image_link">Image-Link</label>
                    <input type="text" name="image_link" id="image_link" class="form-control mb-2" v-model="notify.image_url">
                </div>
                <div class="form-group">
                    <label for="link_text">Link-Text</label>
                    <input type="text" name="link_text" id="link_text" class="form-control mb-2" v-model="notify.link_text">
                </div>
                <div class="form-group">
                    <label for="link_url">Link-Url</label>
                    <input type="text" name="link_url" id="link_url" class="form-control mb-2" v-model="notify.link_url">
                </div>
                <div class="form-group">
                    <a href="javascript:" class="btn btn-sm btn-danger w-100" v-on:click="notifyUsers">Send notification to all users</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import izitoast from "izitoast";

const LINEBREAK = "\r\n";

export default {
    name: "Manage",
    data() {
        return {
            importSetsRunning: false,
            importCardsRunning: false,
            outputLog: '',
            tab: 'shortcuts',
            users: [],
            setGroups: [],
            giveBoosters: {
                userId: undefined,
                boosterSetId: undefined,
                count: 1
            },
            passwordReset: {
                userId: undefined,
                newPassword: ''
            },
            notify: {
                message: '',
                image_url: '',
                link_text: '',
                link_url: '',
            }
        };
    },
    created() {
        this.$store.commit('updateUserData');
        this.fetchUsers();
        this.fetchSets();
    },
    computed: {},
    watch: {},
    methods: {
        regenerateShopItems() {
            axios.post('/api/admin/shop/regenerate').then((response) => {
                this.outputLog += '>> REGENERATED SHOP ITEMS' + LINEBREAK;

                Object.keys(response.data).forEach((key) => {
                    this.outputLog += key + ': ' + response.data[key] + LINEBREAK;
                })

                this.outputLog += LINEBREAK+LINEBREAK;
            });
        },
        importSets() {
            if (this.importSetsRunning) {
                izitoast.error('IMPORT ALREADY RUNNING; STOP IT')
                return false;
            }

            this.importSetsRunning = true;
            axios.post('/api/admin/cards/import').then((response) => {
                this.importSetsRunning = false;
                this.outputLog += '>> IMPORTED CARD SETS' + LINEBREAK;

                response.data.forEach(line => {
                    this.outputLog += line+LINEBREAK;
                });

                this.outputLog += LINEBREAK+LINEBREAK;
            });
        },
        fetchUsers() {
            axios.get('/api/users').then((response) => {
                this.users = response.data;
                this.giveBoosters.userId = this.users[0].id;
                this.passwordReset.userId = this.users[0].id;
            });
        },
        fetchSets() {
            axios.get('/api/all-sets').then((response) => {
                this.setGroups = response.data;
                this.giveBoosters.boosterSetId = this.setGroups[Object.keys(this.setGroups)[0]][0].set_id;
            });
        },
        giveBoostersToUser() {
            axios.post('/api/admin/give', this.giveBoosters).then((response) => {
                izitoast.success({title: 'Gave boosters to user'});
            });
        },
        resetUserPassword() {
            axios.post('/api/admin/set-pw', this.passwordReset).then((response) => {
                izitoast.success({title: 'Set password for user'});
            });
        },
        notifyUsers() {
            axios.post('/api/admin/notify', this.notify).then((response) => {
                izitoast.success({title: 'Sent notifications to '+response.data.message+' users'});
            });
        }
    },
};
</script>


<style scoped lang="scss">
.page-heading {
    background-image: url("/assets/dipocaco/pocas/admin-poca.jpg");
    background-position: center 45%;
}

</style>
